import Http from '@/api/http.js'

export default {
  index(params) {
    return Http.get(`/client_financial_historic`, { params })
  },

  counter(params) {
    return Http.get(`/client_financial_historic/counter`, { params })
  },
}